import * as fromReleaseInfo from '../actions/release-info.actions'
import { createReducer, on, Action } from '@ngrx/store'

export interface State {
  backend_version?: string
  frontend_version?: string
  release_version?: string
  error?: Error | unknown
}

export const initialState: State = {
  backend_version: '-',
  frontend_version: '-',
  release_version: '-',
  error: null,
}

const releaseInfoReducer = createReducer(
  initialState,
  on(fromReleaseInfo.loadReleaseInfo, () => ({ ...initialState })),
  on(fromReleaseInfo.loadReleaseInfoFailure, (state, { error }) => ({ ...state, error })),
  on(fromReleaseInfo.loadReleaseInfoSuccess, (state, { data }) => ({
    ...state,
    ...data,
  })),
)

export function reducer(state: State | undefined, action: Action) {
  return releaseInfoReducer(state, action)
}

export const selectors = {
  getReleaseInfo: (state: State) => state,
}
